import React from 'react';

import { WhyUseTechnology } from '@commons/why-use-technology/WhyUseTechnology';

import { whyUseRustData } from './payload';

export const WhyUseRust = () => {
  return <WhyUseTechnology {...whyUseRustData} />;
};
